import { BaseModalProps, Modal } from '@/components/Modal';
import { useTranslation } from 'react-i18next';
import { UserForm, CreateUserFormData } from './UserForm';
import { CreateUserDto } from '@/lib/api/users';

export interface CreateUserModalProps extends BaseModalProps {
  onCreate: (data: CreateUserDto) => Promise<boolean>;
  isCreating: boolean;
}

export function CreateUserModal({
  open,
  onOpenChange,
  onCreate,
  isCreating,
}: CreateUserModalProps) {
  const { t } = useTranslation();

  const handleSubmit = async (data: CreateUserFormData) => {
    const success = await onCreate({
      email: data.email,
      name: data.name,
      role: data.role,
      remoteId: data.movideskUserId,
      groupId: data.groupId,
      isActive: true,
    });

    if (success) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Modal open={open} onOpenChange={onOpenChange} title={t('users.createModal.title')}>
      <UserForm
        mode="create"
        onSubmit={handleSubmit}
        isLoading={isCreating}
        onCancel={handleCancel}
      />
    </Modal>
  );
}
